import React from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

const AvailableStaysList = ({ state, searchText, onSelect }) => {
  if (state.status === 'loading' || state.status === 'idle') {
    return (
      <Box aria-busy="true" aria-live="polite" sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={32} aria-label="Cargando estadías disponibles" />
      </Box>
    );
  }

  if (state.status === 'error') {
    return <Alert severity="error" aria-live="assertive">No se pudieron cargar las estadías disponibles.</Alert>;
  }

  if (state.results.length === 0) {
    return (
      <Typography role="status" aria-live="polite" sx={{ py: 4, textAlign: 'center' }}>
        {searchText.trim()
          ? 'No se encontraron estadías disponibles.'
          : 'No hay estadías disponibles para salida.'}
      </Typography>
    );
  }

  return (
    <List aria-label="Estadías disponibles para salida">
      {state.results.map((stay) => (
        <ListItemButton
          key={stay.id}
          onClick={() => onSelect(stay)}
          aria-label={`Seleccionar estadía ${stay.id}, placa ${stay.historial.placa}`}
          sx={{
            minHeight: 56,
            alignItems: 'flex-start',
            '&:focus-visible': { outline: '3px solid currentColor', outlineOffset: -3 },
          }}
        >
          <ListItemText
            primary={`Estadía ID: ${stay.id} Cliente: ${stay.cliente.nombre} ${stay.cliente.apellidos}`}
            secondary={`Placa: ${stay.historial.placa} - ${stay.historial.marca} ${stay.historial.modelo}`}
          />
        </ListItemButton>
      ))}
    </List>
  );
};

export default AvailableStaysList;
